import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import imgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import imgHeaderNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/mission-list-header.png";
import iconCoinSuper from "../../../../../assets/images/Mini-Game/Coin (1).png";
import iconCoinSuperNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/coin.png";
import bgMission from "../../../../../assets/images/Event-2026/bg-mission.png";

import { isEmpty } from "lodash";
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../../helper/const";
import "./index.scss";
import {
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../../helper/const";
import snowDeco from "../../../../../assets/images/Mini-Game/new-year-2025/snow-deco.png";

export default function MissionsList({
  title = "Missions to earn attempts",
  children,
  className = "",
  data = [],
}) {
  const { t } = useTranslation();
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  const isShowHasFooter = useMemo(() => {
    if (isEmpty(data)) {
      return false;
    }

    let isCoinSupper = false;
    data.forEach((item = {}) => {
      if (item.supper_coin && +item.supper_coin !== 0) {
        isCoinSupper = true;
      }
    });
    return isCoinSupper;
  }, [data]);

  return (
    <ContainerMission
      id="Mini-game"
      className={`missions-minigame__bg ${className} ${IS_EVENT_THADINGYUT_2025_THEME
        ? "thadingyut-theme"
        : IS_EVENT_NEW_YEAR_2025_THEME
          ? "new-year-25-theme"
          : ""
        }`}
    >
      <div className="minigame-missions-list-container">
        <div className="missions-list">
          <div className="header-mission">
            <div className="position-relative">
              {/* <img
                src={
                  IS_EVENT_NEW_YEAR_2025_THEME ? imgHeaderNewYear : imgHeader
                }
                alt="header-mission"
                className="bg-header-mission"
              /> */}
              <div className="mission-title">{title}</div>
            </div>
          </div>
          <div className="body-missions"> {children}</div>
          {isShowHasFooter ? (
            <div
              className={`footer-missions ${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
                } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""}`}
            >
              <img
                src={
                  IS_EVENT_NEW_YEAR_2025_THEME
                    ? iconCoinSuperNewYear
                    : iconCoinSuper
                }
                alt=""
                className="icon-coin"
              />
              <p>{t("mini_game.homepage.lucky_puzzle_prizes_footer")}</p>
            </div>
          ) : null}
          {
            IS_EVENT_NEW_YEAR_2025_THEME && (
              <SnowDecoWrapper>
                <img src={snowDeco} alt="snow-deco" className="snow-deco-mission-list" />
              </SnowDecoWrapper>
            )
          }
        </div>
      </div>
    </ContainerMission>
  );
}

const SnowDecoWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  pointer-events: none;
  transform: translate(-10%, 50%);
  img {
    max-width: 80%;
  }
`

const ContainerMission = styled.div`
  .minigame-missions-list-container {
    padding: 82px 0 0 0px;
    background-image: url(${bgMission});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position-x: center;
    background-position-y: center;

    @media (max-width: 600px) {
      padding: 60px 0 0 0px;
    }
  }

  &.new-year-25-theme {
    /* .minigame-missions-list-container {
      padding-top: 150px;
    } */
  }

  .body-missions {
    padding: 48px 32px 32px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .missions-list {
    max-width: 85%;
    margin: 0 auto;
    position: relative;
    border-radius: 24px;
    min-height: 280px;

    @media (max-width: 600px) {
      max-width: 98%;
    }
  }

  .header-mission {
    position: absolute;
    top: -31px;
    left: 0;
    // transform: translateX(-50%);
    width: 100%;
    text-align: center;

    @media (max-width: 576px) {
      top: -25px;
    }
  }

  .mission-title {
    position: absolute;
    left: 15px;
    transform: translate(0, -50%);
    top: 50%;
    text-align: left;
    color: #FDDD10;
    font-size: 26px;
    font-weight: 700;
  }

  .footer-missions {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 32px 24px;
    gap: 20px;
    .icon-coin {
      width: 32px;
    }
    p {
      font-style: italic;
      font-size: 18px;
      color: #954911;
    }

    &.thadingyut-theme {
      p {
        color: #fff;
      }
    }

    &.new-year-25-theme {
      p {
        color: #fff;
      }
    }

    @media (max-width: 576px) {
      p {
        font-size: 14px;
      }
    }
  }

  @media (max-width: 1200px) {
    .missions-list {
      max-width: 95%;
    }

    .body-missions {
      padding: 40px 10px 10px;
      padding-top: 20px;
    }
  }

  @media (max-width: 768px) {
    .mission-title {
      font-size: 21px;
    }

    .body-missions {
      padding: 48px 20px 20px;
      padding-top: 20px;
    }

    .bg-header-mission {
      max-width: 90%;
      height: 90px;
    }

    .header-mission {
      top: -26px;
    }
  }

  @media (max-width: 576px) {
    .bg-header-mission {
      max-width: 95%;
      height: 72px;
    }

    .mission-title {
      font-size: 18px;
      min-width: 300px;
    }

    .header-mission {
      top: -27px;
    }

    .body-missions {
      padding: 48px 8px 20px;
      padding-top: 20px;
    }
  }
  @media (max-width: 425px) {
    .mission-title {
      font-size: 16px;
    }
  }

  @media (max-width: 500px) {
    .bg-header-mission {
      max-width: 90%;
      height: 65px;
    }

    .mission-title {
      font-size: 16px;
      min-width: 280px;
    }

    .header-mission {
      top: -20px;
    }
  }
`;
